// src/redux/thunks/announcements/announcements.js
//
// Owner announcements: /v2/announcements on BusinessCoreApi, behind the
// Cognito authorizer. Same base pattern as aiApi and draftsApi: the id token
// goes in the Authorization header, never in the URL.

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { fetchAuthSession } from 'aws-amplify/auth';

const proxyPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
const baseApi     = process.env.REACT_APP_API_BASE_URL || '';
const url         = proxyPrefix + baseApi + 'v2/v2/announcements';

export const announcementsApi = createApi({
  reducerPath: 'announcementsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: async (headers) => {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      if (token) headers.set('Authorization', token);
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Announcements'],
  endpoints: (builder) => ({

    // POST /v2/announcements  { businessId, text }  → 202 { announcementId, status }
    submitAnnouncement: builder.mutation({
      query: ({ businessId, text }) => ({ url: '', method: 'POST', body: { businessId, text } }),
      invalidatesTags: (r, e, { businessId }) => [{ type: 'Announcements', id: businessId }],
    }),

    // GET /v2/announcements?businessId=…  → { announcements: [...] }
    getAnnouncements: builder.query({
      query: ({ businessId, limit = 20 }) => `?businessId=${businessId}&limit=${limit}`,
      providesTags: (r, e, { businessId }) => [{ type: 'Announcements', id: businessId }],
    }),

    // GET /v2/announcements?businessId=…&announcementId=…  → { announcement }
    // Polled while interpretation runs.
    getAnnouncement: builder.query({
      query: ({ businessId, announcementId }) =>
        `?businessId=${businessId}&announcementId=${announcementId}`,
    }),

    // POST /v2/announcements/{id}/discard
    discardAnnouncement: builder.mutation({
      query: ({ announcementId }) => ({ url: `/${announcementId}/discard`, method: 'POST', body: {} }),
      invalidatesTags: (r, e, { businessId }) => [{ type: 'Announcements', id: businessId }],
    }),
  }),
});

export const {
  useSubmitAnnouncementMutation,
  useGetAnnouncementsQuery,
  useGetAnnouncementQuery,
  useDiscardAnnouncementMutation,
} = announcementsApi;